import { GlobalProps } from '@/models/GlobalProps';
import { camelCaseKeys } from './changeCase';

export const globalProps = camelCaseKeys<GlobalProps>(window.globalProps);
